document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.read-more-block').forEach(block => {
    const showBtn = block.querySelector('.read-more-btn');
    const hideBtn = block.querySelector('.read-less-btn');
    const extra   = block.querySelector('.more-text');

    showBtn.addEventListener('click', () => {
      extra.classList.replace('hidden','visible');
      showBtn.setAttribute('aria-expanded','true');
      extra.setAttribute('aria-hidden','false');
    });
    hideBtn.addEventListener('click', () => {
      extra.classList.replace('visible','hidden');
      showBtn.setAttribute('aria-expanded','false');
      extra.setAttribute('aria-hidden','true');
    });
  });
});


